import BallotOutlinedIcon from '@mui/icons-material/BallotOutlined';
import { Alert, AlertTitle, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import { InfoBox } from '@/components/InfoBox';
import Typography from '@/components/Typography';
import { DataHubCard } from '@/features/DataHub/components/DataHubCard';
import { useExport } from '@/features/DataHub/modules/Export/context/ExportContext';
import { useExportSettingsActions } from '@/features/DataHub/modules/Export/hooks/useExportSettingsActions';
import { ExportTypes } from '@/features/DataHub/modules/Export/types';
import useUserDetails from '@/hooks/useUserDetails';

const alertStyles = {
  backgroundColor: 'inherit',
  color: 'inherit',
  py: 1,
  mb: 3,
  '& .MuiAlert-icon': {
    color: 'primary.main',
    paddingTop: 0.5
  }
} as const;

const PremiumFeatureAlert = () => (
  <InfoBox>
    <Alert
      severity='error'
      sx={alertStyles}
    >
      <AlertTitle sx={{ fontSize: '12px', mb: '8px' }}>Data export is a Premium feature</AlertTitle>
      <Typography sx={{ fontSize: '12px' }}>
        GX Go Premium users can export data through our API and many other methods. Upgrade for
        advanced functionality and exports.
      </Typography>
    </Alert>
  </InfoBox>
);

const ExportType = () => {
  const { setPreviewOptionId } = useExport();
  const { exportSettings, updateExportSetting } = useExportSettingsActions();
  const { isUserPremium, isUserExpired } = useUserDetails();

  const handleExportTypeChange = (newExportType: ExportTypes) => {
    updateExportSetting('exportType', newExportType);
    setPreviewOptionId(null);
  };

  const showPremiumAlert = !isUserPremium || isUserExpired;

  return (
    <DataHubCard
      expandable
      icon={<BallotOutlinedIcon sx={{ fontSize: '16px' }} />}
      subtitle='Select export type'
      title='Type'
    >
      {showPremiumAlert && <PremiumFeatureAlert />}
      <RadioGroup
        sx={{ display: 'flex', flexDirection: 'column', gap: 1, fontSize: '14px' }}
        value={exportSettings.exportType}
        onChange={({ target }) => {
          handleExportTypeChange(target.value as ExportTypes);
        }}
      >
        <FormControlLabel
          control={<Radio />}
          label='Data'
          value={ExportTypes.DATA}
        />
        <FormControlLabel
          control={<Radio />}
          label='Image'
          value={ExportTypes.IMAGE}
        />
      </RadioGroup>
    </DataHubCard>
  );
};

export default ExportType;
